import { render, staticRenderFns } from "./HomeForDevelopers.vue?vue&type=template&id=22f623d5&scoped=true&"
import script from "./HomeForDevelopers.vue?vue&type=script&lang=js&"
export * from "./HomeForDevelopers.vue?vue&type=script&lang=js&"
import style0 from "./HomeForDevelopers.vue?vue&type=style&index=0&id=22f623d5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22f623d5",
  null
  
)

export default component.exports